import { format as _format, Locale } from 'date-fns'
import { th, enUS } from 'date-fns/locale'
import i18n from 'config/i18n'

interface Locales {
  th: Locale
  en: Locale
}

const locales: Locales = { th, en: enUS }

const format = (date: Date, formatStr = 'PP'): string => {
  return _format(date, formatStr, {
    locale: locales[i18n.language as keyof Locales] || locales.en,
  })
}

export default format
